import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Hero from '../sections/Hero';
import Services from '../sections/Services';
import Process from '../sections/Process';
import Projects from '../sections/Projects';
import Stats from '../sections/Stats';
import TechStack from '../sections/TechStack';
import Testimonials from '../sections/Testimonials';
import FAQSection from '../sections/FAQ';
import BlogPreview from '../sections/BlogPreview';
import Contact from '../sections/Contact';
import SEO from '../components/SEO';

import seoData from '../data/seo/home.json';
import { FAQ } from '../constants';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.querySelector(location.hash);

        if (element) {
          if (window.lenis) {
            window.lenis.scrollTo(element, { offset: -80 });
          } else {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords?.join(', ') || ''}
        faq={FAQ.map((f) => ({ q: f.question, a: f.answer }))}
      />

      <Hero />
      <Services isPreview={true} />
      <Projects />
      <Process />
      <Stats />
      <TechStack />
      <Testimonials />
      <FAQSection />
      <BlogPreview />
      <Contact />
    </>
  );
};

export default Home;
